import PropTypes from 'prop-types';
import React from 'react';
import { css, cx } from 'emotion';

import theme from 'site-react/theme';

const centeredStyle = css`
  text-align: center;
`;

/*
 * Reset the bottom margin. If a heading needs space below it, use
 * VerticalSpacing.
 */
const headingStyle = css`
  margin: 0;
  display: block;
`;

const Heading = ({ children, color, isCentered, level, type }) => {
  const ElementType = level ? `h${level}` : `span`;
  const colorStyle = css`
    color: ${color ? theme.colors[color] : 'inherit'};
  `;

  return (
    <ElementType
      className={cx(
        headingStyle,
        isCentered && centeredStyle,
        type === 'title1' && theme.titleText1,
        type === 'title2' && theme.titleText2,
        type === 'title3' && theme.titleText3,
        type === 'title4' && theme.titleText4,
        type === 'content1' && theme.contentText1,
        type === 'content2' && theme.contentText2,
        type === 'content3' && theme.contentText3,
        type === 'hero' && theme.heroText,
        colorStyle,
      )}
    >
      {children}
    </ElementType>
  );
};

Heading.defaultProps = {
  children: null,
  isCentered: false,
  color: null,
};

Heading.propTypes = {
  /**
   * Content to show in the heading.
   */
  children: PropTypes.node,

  /**
   * Color of the heading
   */
  color: PropTypes.oneOf(['neutral900', 'white']),

  /**
   * Should this heading be centered?
   */
  isCentered: PropTypes.bool,

  /**
   * The heading level. Level '1' gives an h1, '2' an h2, etc. etc.
   */
  level: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']),

  /**
   * The type of heading. Corresponds to our theming variables.
   */
  type: PropTypes.oneOf([
    'content1',
    'content2',
    'content3',
    'title1',
    'title2',
    'title3',
    'title4',
    'hero',
  ]).isRequired,
};

export default Heading;
